module.exports = __webpack_public_path__ + "media/eddie_she_came_in_and_seduced_me.6f382e55.mp3";